import { useContext } from 'react';

import { AuthContext } from '../model';

export function useAuthContext() {
  return useContext(AuthContext);
}
